import moment from "moment";
import {
  TRACKING_KEY_VALUE_SEPARATE_CHAR,
  TRACKING_KEY_VALUE_START_CHAR,
  TRACKING_PARAMETER_SEPARATE_CHAR
} from "../pages/ADVERTISEMENT/ms/common/CommonConst";
import {TargetInfo} from "../pages/ADGROUP/ms/common/AdGroupModel";
import {CHECKED, INIT_NUMBER, TARGET_TYPE} from "../pages/ADGROUP/ms/common/CommonConst";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {fill, toString} from "lodash";
import {ApolloBasicTextField} from "../molecule/Apollo_BaseItem";

import iconv from "iconv-lite"
import {TextField} from "@material-ui/core";
import {
  BLANK,
  FULL_SPACE,
  PREFIX_REQUEST_PARAM,
  SHIFT_JIS,
  SPACE_END_CHAR_PATTERN,
  SPACE_START_CHAR_PATTERN,
  SUBJECT_VALID_PATTERN,
  TEXT_VALID_CONTROL_CHAR_PATTERN,
  TEXT_VALID_TAB_CHAR_PATTERN,
  TEXT_VALID_PATTERN, TEXT_VALID_PATTERN_DOUBLE_QUOTE,
  DOT_START_CHAR_PATTERN,
  TEXT_VALID_PATTERN_REPORT,
  SQL_VALID_CHAR_REPORT_PATTERN,
} from "../pages/CRASSET/ms/common/CommonConst";
import {ColumnData, CsvData} from "./Apollo_CommonConst";
import {ApolloAxios} from "../atom/Apollo_ApiRequest3";
import {
  hera_account_path,
  hera_audiences_path,
  hera_setpoints_path,
} from "../atom/Apollo_links";
import {
  AudienceWithUu,
  DeletedAudience,
  DeletedSetPoint,
  SetPoint,
} from "../pages/HERA/HeraModel";
import { Buffer } from 'buffer';

export const TRACKING_PARAM_MACRO_STR = [
  {str: "\{dad_pf_id\}", size: 1},
  {str: "\{dad_cp_id\}", size: 7},
  {str: "\{dad_cr_id\}", size: 9},
  {str: "\{dad_cl_id\}", size: 8},
  {str: "\{dad_adg_id\}", size: 7},
  {str: "\{dad_link_id\}", size: 2},
]

export const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return "";
  } else {
    return option.label;
  }
};

export const valueToOption = function (value: any, options: Array<{ value: any; label: string }>): { value: any; label: string } | null {
  let option = options?.find(option => option.value === value)
  if (!option) {
    return null
  } else {
    return option
  }
}

export const scheduleStringToArray = function (scheduleString: string) {
  const scheduleArray = JSON.parse(scheduleString)
  const scheduleArrayBoolean = scheduleArray.map((row: any) => {
    return row.map((value: number) => value === 1 ? true : false)
  })
  return scheduleArrayBoolean
}

export const scheduleArrayToString = function (scheduleArray: boolean[][]) {
  const scheduleArrayNumber = scheduleArray.map(row => {
    return row.map(value => value === true ? 1 : 0)
  })
  const scheduleStringNumber = JSON.stringify(scheduleArrayNumber)
  return scheduleStringNumber
}

export const toUtcIso8601str = (momentInstance: moment.Moment) => {
  return momentInstance
    .clone()
    // .utc()
    .format('YYYY-MM-DD')
}

export const getTrackingArrayItems = (trackingValuesStr: string) => {
  let maxIndex = 0;
  const arrayItems =
    trackingValuesStr ? (
      trackingValuesStr.split(TRACKING_PARAMETER_SEPARATE_CHAR).map((param: string) => {
        const keyValue = param.split(TRACKING_KEY_VALUE_SEPARATE_CHAR)
        const key = keyValue[0]
        const value = keyValue[1]
        return {
          id: maxIndex++,
          key: key,
          value: value,
        }
      }))
      : []
  return arrayItems
}

export type TrackingItem = {
  id: number,
  key: string,
  value: string,
}

export const joinTrackingValue = (trackingArray: TrackingItem[]) => {

  const joinStr = trackingArray.map((tracking: TrackingItem) => {
    return (
      `${tracking.key}${TRACKING_KEY_VALUE_SEPARATE_CHAR}${tracking.value}`
    )
  }).join(TRACKING_PARAMETER_SEPARATE_CHAR)

  return joinStr
}

export const getTrackingMacroLength = (trackingArray: TrackingItem[]) => {

  const encodedStr = trackingArray.map((tracking: TrackingItem) => {

    const replacedMacroStrKey = replaceMacroStr(tracking.key)
    const replacedMacroStrValue = replaceMacroStr(tracking.value)
    return (
      `${encodeInvalidChar(encodeURIComponent(replacedMacroStrKey))}${TRACKING_KEY_VALUE_SEPARATE_CHAR}${encodeInvalidChar(encodeURIComponent(replacedMacroStrValue))}`
    )
  }).join(TRACKING_PARAMETER_SEPARATE_CHAR)

  const resultStr = encodedStr && TRACKING_KEY_VALUE_START_CHAR + encodedStr
  return resultStr.length
}

export const replaceMacroStr = (targetStr: string) => {
  let tmpStr = targetStr
  TRACKING_PARAM_MACRO_STR.forEach((elem, index) => {
    tmpStr = tmpStr.replace(new RegExp(elem.str, 'g'), "X".repeat(elem.size));
  });
  return tmpStr
}

export const transferTargetInfo = (targetInfo: TargetInfo, prefecture: number[]) => {

  let retTargetInfo: TargetInfo = {
    targetType: targetInfo.targetType,
    targetId: INIT_NUMBER,
    targetIdfForCustom: INIT_NUMBER,
    targetIdForRetage: INIT_NUMBER,
    gender: [],
    age: [],
    prefecture: [],
    sugotoku: [],
    category: [],
    geopointid: [],
  }

  if (retTargetInfo.targetType === TARGET_TYPE.DEMOGRA) {
    if (targetInfo.sugotoku[0] === CHECKED) {
      retTargetInfo.sugotoku = targetInfo.sugotoku
    } else {
      retTargetInfo.gender = targetInfo.gender
      retTargetInfo.age = targetInfo.age[0] === null ? [] : targetInfo.age
      retTargetInfo.prefecture = prefecture
      retTargetInfo.category = targetInfo.category
    }

  } else if (retTargetInfo.targetType === TARGET_TYPE.CUSTOM) {
    retTargetInfo.targetId = targetInfo.targetIdfForCustom
  } else if (retTargetInfo.targetType === TARGET_TYPE.RETAGE) {
    retTargetInfo.targetId = targetInfo.targetIdForRetage
  } else if (retTargetInfo.targetType === TARGET_TYPE.GEOTARGET) {
    retTargetInfo.targetId = targetInfo.targetId
    retTargetInfo.geopointid = targetInfo.geopointid
  } else if (retTargetInfo.targetType === TARGET_TYPE.GEOTARGET_DEMOGRA) {
    retTargetInfo.targetId = targetInfo.targetId
    retTargetInfo.gender = targetInfo.gender
    retTargetInfo.age = targetInfo.age[0] === null ? [] : targetInfo.age
    retTargetInfo.prefecture = prefecture
    retTargetInfo.geopointid = targetInfo.geopointid
  }

  return retTargetInfo
}

export const TrackingPointItem: React.FC<{
  values: TrackingItem[],
  setState: any,
  register: any,
  errors: any,
  clearErrors: any,
  disabled?: boolean,
}> = ({values, setState, register, errors, clearErrors, disabled}) => {

  const ret = values.map((elem, index, array) => {

    const baseID = `${index + 1}`

    const keyId = `key${baseID}`
    const valueId = `value${baseID}`

    return (
      <Grid container style={{marginTop: "10px", marginBottom: "10px", marginLeft: "3px"}}>
        <Grid item xs={1}>
          <Button type="button"
            id={toString(elem.id)}
            disabled={disabled}
            variant="contained"
            color="secondary"
            onClick={(e) => {
              const nonDelTarget = values.filter(elem => toString(elem.id) !== e.currentTarget.id)
              setState(nonDelTarget)
              clearErrors([keyId, valueId])
            }}>削除</Button>
        </Grid>
        <Grid item xs={3}>
          <ApolloBasicTextField
            id={keyId}
            label={keyId}
            value={elem.key}
            error={errors[keyId]}
            required={true}
            disabled={disabled}
            inputRef={register({
              required: "必須です",
              pattern: {
                value: /^[!#-%(-;@-[\]_a-{}-~]+$/,
                message: '禁止文字が含まれます。',
              },
              validate: (e: string) => {
                return checkCommonInvalidTextChar(e);
              },
            })}
            setState={(e: any) => setState(fill([...array], {
              ...elem,
              key: e,
            }, index, index + 1))}
          />
        </Grid>
        <Grid item xs={3}>
          <ApolloBasicTextField
            id={valueId}
            label={valueId}
            value={elem.value}
            error={errors[valueId]}
            required={true}
            disabled={disabled}
            inputRef={register({
              required: "必須です",
              pattern: {
                value: /^[!#-%(-;@-[\]_a-{}-~]+$/,
                message: '禁止文字が含まれます。'
              },
              validate: (e: string) => {
                return checkCommonInvalidTextChar(e);
              },
            })}
            setState={(e: any) => setState(fill([...array], {
              ...elem,
              value: e,
            }, index, index + 1))}
          />
        </Grid>
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Preview"
            disabled={true}
            variant={"standard"}
            value={`${elem.key}${elem.value && "="}${elem.value}`}
          />
        </Grid>
      </Grid>
    );
  })
  return <React.Fragment>{ret}</React.Fragment>
}

export const convertBrTag = (value: string) => {
  return (
    value.split('\n').map((str) => (
      <React.Fragment>{str}<br/></React.Fragment>
    ))
  )
}

export const encodeInvalidChar = (value: string) => {
  return value.replace(/[!'()*]/g, function (c: any) {
    return '%' + c.charCodeAt(0).toString(16)
  }).replace(/-/g, "%2d")
    .replace(/\./g, "%2e")
    .replace(/~/g, "%7e")
}

export const sortStringToNumber = (order: string) => {
  return (obj1: any, obj2: any) => {
    // console.log(order);
    let val1 = parseInt(obj1.data, 10);
    let val2 = parseInt(obj2.data, 10);
    return (val1 - val2) * (order === 'asc' ? 1 : -1);
  };
}

export const checkCommonInvalidTextChar = (targetStr: string) => {
  return targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) || "制御文字（タブ文字）は入力できません。"
}

export const checkCommonInvalidTabChar = (targetStr: string) => {
    return targetStr.match(TEXT_VALID_TAB_CHAR_PATTERN) || "制御文字（タブ文字）は入力できません。"
}

export const checkInvalidCharForName = (targetStr: string) => {

  if(targetStr === BLANK) {
    return BLANK
  }

  let retMessage = !targetStr.match(SPACE_START_CHAR_PATTERN) ? "文頭にはスペースを入力できません。" :
    !targetStr.match(SPACE_END_CHAR_PATTERN) ? "文末にはスペースを入力できません。" :
      !targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) ? "制御文字（タブ文字）は入力できません。" :
        !targetStr.match(TEXT_VALID_PATTERN) ? "禁止文字が含まれます。" : BLANK

  if (!retMessage) {
    retMessage = checkSjisStr(targetStr)
  }

  return retMessage
}

export const checkInvalidTabCharsForName = (targetStr: string) => {

  if(targetStr === BLANK) {
    return BLANK
  }

  let retMessage = !targetStr.match(SPACE_START_CHAR_PATTERN) ? "文頭にはスペースを入力できません。" :
    !targetStr.match(SPACE_END_CHAR_PATTERN) ? "文末にはスペースを入力できません。" :
    !targetStr.match(TEXT_VALID_TAB_CHAR_PATTERN) ? "制御文字（タブ文字）は入力できません。" :
    !targetStr.match(TEXT_VALID_PATTERN) ? "禁止文字が含まれます。" : BLANK

    if (!retMessage) {
      retMessage = checkSjisStr(targetStr)
    }

    return retMessage
}

export const checkInvalidCharForImageFileName = (targetStr: string) => {

    if(targetStr === BLANK) {
    return BLANK
  }

  let retMessage = !targetStr.match(SPACE_START_CHAR_PATTERN) ? "文頭にはスペースを入力できません。" :
    !targetStr.match(SPACE_END_CHAR_PATTERN) ? "文末にはスペースを入力できません。" :
      !targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) ? "制御文字（タブ文字）は入力できません。" :
        !targetStr.match(TEXT_VALID_PATTERN) ? "禁止文字が含まれます。" :
          !targetStr.match(TEXT_VALID_PATTERN_DOUBLE_QUOTE) ? "禁止文字が含まれます。" : BLANK

  if (!retMessage) {
    retMessage = checkSjisStr(targetStr)
  }

  return retMessage
}

export const checkInvalidTabCharForImageFileName = (targetStr: string) => {

    if(targetStr === BLANK) {
        return BLANK
    }

    let retMessage = !targetStr.match(SPACE_START_CHAR_PATTERN) ? "文頭にはスペースを入力できません。" :
      !targetStr.match(SPACE_END_CHAR_PATTERN) ? "文末にはスペースを入力できません。" :
      !targetStr.match(TEXT_VALID_TAB_CHAR_PATTERN) ? "制御文字（タブ文字）は入力できません。" :
      !targetStr.match(TEXT_VALID_PATTERN) ? "禁止文字が含まれます。" :
      !targetStr.match(TEXT_VALID_PATTERN_DOUBLE_QUOTE) ? "禁止文字が含まれます。" : BLANK

    if (!retMessage) {
        retMessage = checkSjisStr(targetStr)
    }

    return retMessage
}

// MS広告アセット　URL許容文字
const URL_VALID_START_PATTERN_START = /^https:\/\/.+$/
const URL_VALID_CHAR_PATTERN = /^[!#-&(-;=?-[\]_a-{}-~]*$/

const DOMAIN_VALID_CHAR_PATTERN = /^[a-zA-Z0-9.:%-]*$/
const DOMAIN_VALID_CHAR_PATTERN_ARROW_UNDERBAR = /^[a-zA-Z0-9.:%-_]*$/

const checkValueMaxLength512 = 512

const checkMessageTextMaxByte512 = "512バイト以内で入力して下さい。"

export const checkMessageTextInvalidStartURLPattern = "URLが不正です。https://の後に文字を指定する必要があります。"
export const checkMessageTextInvalidCharURLPattern = "URLに禁止文字が含まれます。"

const checkMessageTextInvalidCharDomainPattern = "ドメインに禁止文字が含まれます。"

export const checkUrlStrWithLength = (uriStr: String) => {

  let retErrorMessage = BLANK

  if (uriStr === BLANK) {
    return retErrorMessage
  }

  if (uriStr.search(URL_VALID_START_PATTERN_START) === -1) {
    retErrorMessage = checkMessageTextInvalidStartURLPattern
  } else if (uriStr.search(URL_VALID_CHAR_PATTERN) === -1) {
    retErrorMessage = checkMessageTextInvalidCharURLPattern
  } else if (encodeUriOnlyParam(uriStr).length > checkValueMaxLength512) {
    retErrorMessage = checkMessageTextMaxByte512
  }

  return retErrorMessage
}

export const checkUrlStr = (uriStr: String) => {

  let retErrorMessage = BLANK

  if (uriStr === BLANK) {
    return retErrorMessage
  }

  if (uriStr.search(URL_VALID_START_PATTERN_START) === -1) {
    retErrorMessage = checkMessageTextInvalidStartURLPattern
  } else if (uriStr.search(URL_VALID_CHAR_PATTERN) === -1) {
    retErrorMessage = checkMessageTextInvalidCharURLPattern
  }

  return retErrorMessage
}

export const checkDomainStr = (domainStr: String) => {

  let retErrorMessage = BLANK

  if (domainStr === BLANK) {
    return retErrorMessage
  }

  if (domainStr.search(DOMAIN_VALID_CHAR_PATTERN) === -1) {
    retErrorMessage = checkMessageTextInvalidCharDomainPattern
  }

  return retErrorMessage
}

export const checkDomainStrArrowUnderbar = (domainStr: String) => {

  let retErrorMessage = BLANK

  if (domainStr === BLANK) {
    return retErrorMessage
  }

  if (domainStr.search(DOMAIN_VALID_CHAR_PATTERN_ARROW_UNDERBAR) === -1) {
    retErrorMessage = checkMessageTextInvalidCharDomainPattern
  }

  return retErrorMessage
}

const encodeUriOnlyParam = (uriStr: String) => {
  let retUri = uriStr
  const elems = uriStr.split(PREFIX_REQUEST_PARAM)
  if (elems.length > 1) {
    const [urlStr, paramsStr]
      = [elems[0], elems.slice(1)
        .map(elem => {
          const uri = replaceMacroStr(elem)
          return encodeInvalidChar(encodeURIComponent(uri)).replace(/%3D/g, "=").replace(/%26/g, "&")
        }
        )
      ]
    retUri = [urlStr, ...paramsStr].join(PREFIX_REQUEST_PARAM)
  }
  return retUri
}

export const checkSjisStr = (targetStr: string) => {
  const byteSjis = iconv.encode(targetStr, SHIFT_JIS);
  // SJISのバイト文字列へ変換
  const strUtf8 = iconv.decode(Buffer.from(byteSjis), SHIFT_JIS);
  // 変換後の文字列が一致するか確認(文字化けしていなければ一致)
  const retValue = targetStr === strUtf8
  // 変換後の文字列が一致するか確認(文字化けしていなければ一致)
  return retValue ? "" : "禁止文字が含まれます。";
}

export const arrayChunk = (array: any[], size: number) => {
  return array.reduce((acc, value, index) => index % size ? acc : [...acc, array.slice(index, index + size)], []);
}

export const createApolloCsvBlob = (columns: ColumnData[], csvData: CsvData[]): Blob => {
  const csv: string[][] = [];
  const headers = columns?.map(column => formatApolloCsvCell(column.label));
  csv.push(headers);
  csvData.map(d => csv.push(d.data));
  const rows = csv.map(e => e.join(",")).join("\n")
  const bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  return new Blob([bom, rows], {type: 'text/csv'});
}

// テスト用コード
//checkInvalidChar()

const checkMessageTextInvalidStartSpace = "先頭に全角スペースは入力できません。"
const checkMessageTextInvalidTabChar = "制御文字（タブ文字）は入力できません。"
const checkMessageTextInvalidPattern = "禁止文字が含まれます。"

export const getSubjectStrCheckErrorMsg = (
  targetStr: string,
) => {
  let retMeassage = BLANK

  retMeassage= targetStr.startsWith(FULL_SPACE) ? checkMessageTextInvalidStartSpace :
    !targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) ? checkMessageTextInvalidTabChar :
      !targetStr.match(SUBJECT_VALID_PATTERN) ? checkMessageTextInvalidPattern : BLANK

  if(!retMeassage) {
    retMeassage  = checkSjisStr(targetStr)
  }
  return retMeassage
}

export const getSubjectStrCheckErrorMsgForTabChar = (
  targetStr: string,
) => {
  let retMeassage = BLANK

  retMeassage= targetStr.startsWith(FULL_SPACE) ? checkMessageTextInvalidStartSpace :
    !targetStr.match(TEXT_VALID_TAB_CHAR_PATTERN) ? checkMessageTextInvalidTabChar :
    !targetStr.match(SUBJECT_VALID_PATTERN) ? checkMessageTextInvalidPattern : BLANK

  if(!retMeassage) {
    retMeassage  = checkSjisStr(targetStr)
  }
  return retMeassage
}

export const getTextStrCheckErrorMsg = (
  targetStr: string,
) => {
  let retMeassage = BLANK

  retMeassage = !targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) ? checkMessageTextInvalidTabChar :
    !targetStr.match(TEXT_VALID_PATTERN) ? checkMessageTextInvalidPattern : BLANK

  if(!retMeassage) {
    retMeassage  = checkSjisStr(targetStr)
  }
  return retMeassage
}

export const getTextStrCheckErrorMsgForTabChar = (
  targetStr: string,
) => {
  let retMeassage = BLANK

  retMeassage = !targetStr.match(TEXT_VALID_TAB_CHAR_PATTERN) ? checkMessageTextInvalidTabChar :
    !targetStr.match(TEXT_VALID_PATTERN) ? checkMessageTextInvalidPattern : BLANK

  if(!retMeassage) {
    retMeassage  = checkSjisStr(targetStr)
  }
  return retMeassage
}

export const formatApolloCsvCell = (cellData: string | number, escapeWQ?: boolean): string => {
  if(escapeWQ && typeof cellData === "string") {
    return `\"${cellData?.replace(/"/g, `\"\"`)}\"`;
  } else {
    return `\"${cellData}\"`;
  }
}

export const checkInvalidCharForReportName = (targetStr: string): string => {

  if(targetStr === BLANK) {
    return BLANK
  }

  let retMessage = !targetStr.match(SPACE_START_CHAR_PATTERN) ? "文頭にはスペースを入力できません。" :
    !targetStr.match(SPACE_END_CHAR_PATTERN) ? "文末にはスペースを入力できません。" :
      !targetStr.match(TEXT_VALID_CONTROL_CHAR_PATTERN) ? "制御文字（タブ文字）は入力できません。" :
        !targetStr.match(DOT_START_CHAR_PATTERN) ? "文頭にはドットを入力できません。" :
          !targetStr.match(TEXT_VALID_PATTERN_REPORT) ? "禁止文字が含まれます。" :
            !targetStr.match(SQL_VALID_CHAR_REPORT_PATTERN) ? "禁止文字が含まれます。" :
              BLANK

  if (!retMessage) {
    retMessage = checkSjisStr(targetStr)
  }

  return retMessage
}

export const getTrackerAudience = async(trackerId: string): Promise<{result: AudienceWithUu[], message: string}> => {
  let ret: {result: AudienceWithUu[], message: string} = {result: [], message: ""};

  const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`
  await ApolloAxios.get(url).then(response => {
    if (response.status !== 200) {
      ret.message = "オーディエンス情報の取得に失敗しました。";
    } else {
      ret.result = response.data?.result ?? [];
    }
  }).catch(err => {
    ret.message = err.errmsg;
  });

  return ret;
}

export const getTrackerSetPoint = async(trackerId: string): Promise<{result: SetPoint[], message: string}> => {
  let ret: {result: SetPoint[], message: string} = {result: [], message: ""};

  const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}`;
  await ApolloAxios.get(url).then(response => {
    if (response.status !== 200) {
      ret.message = "測定ポイント情報の取得に失敗しました。";
    } else {
      ret.result = response.data?.result ?? [];
    }
  }).catch(err => {
    ret.message = err.errmsg;
  });

  return ret;
}

export const getAccountsDeletedAudience = async(accountId: number): Promise<{result: DeletedAudience[], message: string}> => {
  let ret: {result: DeletedAudience[], message: string} = {result: [], message: ""};

  const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${accountId}/audiences/deleted`;
  await ApolloAxios.get(url).then(response => {
    if (response.status !== 200) {
      ret.message = "オーディエンス情報の取得に失敗しました。";
    } else {
      ret.result = response.data?.result ?? [];
    }
  }).catch(err => {
    ret.message = err.errmsg;
  });

  return ret;
}

export const getAccountDeletedSetPoints = async(accountId: number): Promise<{result: DeletedSetPoint[], message: string}> => {
  let ret: {result: DeletedSetPoint[], message: string} = {result: [], message: ""};

  const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${accountId}/setpoints/deleted`;
  await ApolloAxios.get(url).then(response => {
    if (response.status !== 200) {
      ret.message = "測定ポイント情報の取得に失敗しました。";
    } else {
      ret.result = response.data?.result ?? [];
    }
  }).catch(err => {
    ret.message = err.errmsg;
  });

  return ret;
}

interface SizeRule {
  minWidth: number;
  maxHeight: number;
  maxWidth?: number;
  widthRatio: number;
  heightRatio:number;
  imageSizeType: number;
}

// 画像の許容サイズ情報
export const sizeRules: SizeRule[] = [
  { minWidth: 100, maxHeight: 300, maxWidth: 300, widthRatio: 1, heightRatio: 1, imageSizeType: 1 },
  { minWidth: 600, maxHeight: 628, maxWidth: 1200, widthRatio: 19, heightRatio: 10, imageSizeType: 2 },
  { minWidth: 832, maxHeight: 468, widthRatio: 16, heightRatio: 9, imageSizeType: 3 },
  { minWidth: 640, maxHeight: 200, widthRatio: 16, heightRatio: 5, imageSizeType: 4 },
  { minWidth: 300, maxHeight: 500, maxWidth: 600, widthRatio: 6, heightRatio: 5, imageSizeType: 5 },
  { minWidth: 640, maxHeight: 360, widthRatio: 16, heightRatio: 9, imageSizeType: 6 },
];

export const imageSizeMessages = [
  { imageSizeType: 1, Message: "・300x300と同比率かつ幅100-300px"},
  { imageSizeType: 2, Message: "・1200x628と同比率かつ幅600-1200px"},
  { imageSizeType: 5, Message: "・600x500と同比率かつ幅300-600px"},
  { imageSizeType: 6, Message: "・640x360と同比率かつ幅640-640px"},
]

/**
 * validateImage 入稿画像のサイズと比率を検証する
 * 
 * 検証内容
 * 1. 横幅がsizeRules内のいずれかのルールを満たしているかチェック
 * 2. 該当ルールの許容比率と比較し、誤差2%以内であるかチェック
 * 
 * checkImageSizeTypeList: チェック対象の分類番号リスト、指定しなければ全チェックとなる
 */
export const validateImage = (width: number, height: number, checkImageSizeTypeList?: number[]): string | null => {
  let isWidthValid = false;
  let isAspectRatioValid = false;

  for (const rule of sizeRules) {
    // チェックする分類番号が指定されている場合チェック対象以外はスキップ
    if (checkImageSizeTypeList !== undefined && !checkImageSizeTypeList.includes(rule.imageSizeType)) {
      continue;
    }

    if (width < rule.minWidth || (rule.maxWidth ? width > rule.maxWidth : width !== rule.minWidth)) {
      continue;
    }
    isWidthValid = true;

    isAspectRatioValid = isEqualAspectRatio(width, height, rule);
    if (isAspectRatioValid) {
      break;
    }
  }

  if (!isAspectRatioValid || !isWidthValid) {
    return "画像のサイズが規定外です。詳しくは管理画面マニュアルの広告アセットのページをご確認ください。";
  }

  return null;
};

/**
 * isEqualAspectRatio - 比率の誤差許容アスペクト比判定
 */
export const isEqualAspectRatio = (width: number, height: number, rule: { heightRatio: number; widthRatio: number }): boolean => {
  const permissibleError = width * rule.heightRatio * 0.02 // 許容誤差
  return Math.abs(width * rule.heightRatio - height * rule.widthRatio) <= permissibleError
}

/**
 * getImageSizeType 画像分類番号を返却する
 */
export const getImageSizeType = (width: number, height: number): number => {
  let imageSizeType: number = 0;
  for (const rule of sizeRules) {
    if (isEqualAspectRatio(width, height, rule)) {
        imageSizeType = rule.imageSizeType;
        break;
    }
  }

  return imageSizeType;
}

// Hera オーディエンス・測定ポイント登録 正規表現
export const reWhitespace = /[\s\u3000]/; // 空白チェック
export const reBannedChars = /[\\'|`^"<>]/; // 禁止文字チェック
export const reHttpsPrefix = /^https:\/\/.+$/; // httpsチェック